/**
 * Created by serdar.aglamis on 7.06.2017.
 */
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    Cookie.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
        else {
            return false;
        }
    };
    Cookie.setCookie = function (key, value, timestamp) {
        document.cookie = key + '=' + value + "; SameSite=None;secure" + '; expires=' + timestamp.toUTCString();
    };
    return Cookie;
}());
//# sourceMappingURL=cookie.js.map